var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "86A1C1CE-84F7-4EE6-A508-8F7DC871D6E6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets_Admin",
    transform: "translate(-166.000000, -372.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Close",
    transform: "translate(166.000000, 372.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFCB05",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#020303",
    points: "19.8298361 9.51219512 15.8435734 13.4984578 15.8172037 13.471827 15.7905729 13.4984578 11.8043103 9.51219512 10.5121951 10.8043103 14.4984578 14.7905729 10.5121951 18.7765745 11.8043103 20.0686897 15.7905729 16.0826881 15.8172037 16.1093189 15.8435734 16.0826881 19.8298361 20.0686897 21.1219512 18.7765745 17.1359496 14.7905729 21.1219512 10.8043103"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.fd58af30c4e2e7cd94589b01a7bc382b.svg";
export { ForwardRef as ReactComponent };